// 关于我们  隐私协议
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter } = apiList

export default axios => ({
  terms: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/index/app/terms-v1`, params) // 获取关于我们，隐私政策等
})
